module.exports = __webpack_public_path__ + "img/logo_kredivo.44c21c59.png";